const driversChangedMap = {
  // violations
  'quote.drivers.0.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.1.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.2.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.3.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.4.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.5.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.6.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.7.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.8.autoViolationsForUW': 'Auto Violation Data',
  'quote.drivers.9.autoViolationsForUW': 'Auto Violation Data',

  // claims
  'quote.drivers.0.claimCount': 'Claims information - Auto',
  'quote.drivers.1.claimCount': 'Claims information - Auto',
  'quote.drivers.2.claimCount': 'Claims information - Auto',
  'quote.drivers.3.claimCount': 'Claims information - Auto',
  'quote.drivers.4.claimCount': 'Claims information - Auto',
  'quote.drivers.5.claimCount': 'Claims information - Auto',
  'quote.drivers.6.claimCount': 'Claims information - Auto',
  'quote.drivers.7.claimCount': 'Claims information - Auto',
  'quote.drivers.8.claimCount': 'Claims information - Auto',
  'quote.drivers.9.claimCount': 'Claims information - Auto',

  'quote.drivers.0.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.1.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.2.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.3.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.4.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.5.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.6.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.7.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.8.insuranceScore.autoTotal': 'Driver Insurance Score',
  'quote.drivers.9.insuranceScore.autoTotal': 'Driver Insurance Score'
};

export const itemsChangedMap = {
  // home items
  'quote.home.replacementCostEstimate.total': 'Replacement cost and dwelling limit',
  'quote.home.fpc': 'Fire protection class',
  'quote.home.roofYear': 'Roof Age',
  'quote.home.roofShape': 'Roof Shape',
  'quote.home.homeQuality': 'Home Quality',
  'quote.homeClaimsForUW': 'Claims information - Home',

  // auto items
  'quote.global.priorIndividualBILimit': 'Prior individual BI limit',
  'quote.global.priorOccurrenceBILimit': 'Prior occurrence BI limit',
  'quote.global.currentAutoCarrierStartDate': 'Years continuous prior coverage',
  ...driversChangedMap
};

export const getNewPricing = (newOffer) => {
  if (!newOffer?.options || newOffer.quote?.selectedOption === undefined) {
    return null;
  }

  const selectedOptionType = newOffer.quote.selectedOption;

  // Find the selected option in the new offer
  const newOption = newOffer.options.find((option) => option.type === selectedOptionType);

  if (!newOption) {
    return null;
  }

  const pricing = {};

  // Auto pricing (6 months)
  if (newOption.autoTotal !== undefined) {
    pricing.auto = {
      total: newOption.autoTotal,
      period: '6 months'
    };
  }

  // Home pricing (12 months)
  if (newOption.homeTotal !== undefined) {
    pricing.home = {
      total: newOption.homeTotal,
      period: '12 months'
    };
  }

  return pricing;
};
